export default __webpack_public_path__ + "assets/media/favicon180.2203d4e1ab19ace5f91d29a1dbc22a97.png";